<script>
import options from './FundraisingAsideVue.options'
export default options
</script>

<template>

  <aside class="kb-aside kb-aside--fundraising-aside kb-fundraising-aside-vue">

    <div class="kb-fundraising-aside__content-container">

      <template v-if="detailItems?.length > 0 || creatorProfile">

        <h2 class="kb-fundraising-aside__title">
          {{getLabel("title")}}
        </h2>

        <div class="kb-fundraising-aside__wrapper">

          <template v-if="creatorProfile?.firstName && creatorProfile?.lastName">

            <ul class="kb-fundraising-aside__item">
                <li class="kb-fundraising-aside__item-icon kb-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"> <path fill="#3C3C3C" fill-rule="evenodd" d="M5 4h1v2h6V4h1v2h6V4h1v2h6V4h1v2h2a1 1 0 0 1 1 1v19a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h2V4Zm21 3v2h1V7h2v4H3V7h2v2h1V7h6v2h1V7h6v2h1V7h6Zm3 5v14H3V12h26Z" clip-rule="evenodd"/> </svg>
                </li>
                <li class="kb-fundraising-aside__item-content">
                  <h3>{{getLabel("creatorProfileLabel")}}</h3>
                  <p class="kb-fundraising-aside__item-content-text">
                    {{ creatorProfile.firstName + ' ' + creatorProfile.lastName}}
                  </p>
                </li>
              </ul>
          
          </template>

          <template v-for="item, index in detailItems" :key="index">

              <ul class="kb-fundraising-aside__item">
                <li class="kb-fundraising-aside__item-icon kb-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"> <path fill="#3C3C3C" fill-rule="evenodd" d="M5 4h1v2h6V4h1v2h6V4h1v2h6V4h1v2h2a1 1 0 0 1 1 1v19a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h2V4Zm21 3v2h1V7h2v4H3V7h2v2h1V7h6v2h1V7h6v2h1V7h6Zm3 5v14H3V12h26Z" clip-rule="evenodd"/> </svg>
                </li>
                <li class="kb-fundraising-aside__item-content">
                  <h3>{{item.title}}</h3>
                  <p class="kb-fundraising-aside__item-content-text">
                    {{ item.description }}
                  </p>
                </li>
              </ul>

          </template>

        </div>
      </template>

      <template v-if="!isAuthenticated || ownsPersonalFundraising">
        <div class="kb-fundraising-aside__button-wrapper">
          <a :href="loginLogoutButton.link" class="kb-button">{{isAuthenticated ? getLabel("logoutButtonText") : getLabel("loginButtonText")}}</a>
        </div>
      </template>

    </div>

    <template v-if="ownsPersonalFundraising">
      <div class="kb-fundraising-aside__link-wrapper">
        <a :href="editFundraising.link"  class="kb-fundraising-aside__link-wrapper__link">
          <span class="kb-ui-icon kb-ui-icon--ui-pen"></span>{{getLabel("editFundraisingText")}}</a>
      </div>
    </template>

    <div class="kb-fundraising-aside__link-wrapper" v-if="useQrCode">
      <button @click="openPageOverlay" class="kb-fundraising-aside__link-wrapper__link">
        <div class="kb-fundraising-aside__QR-img">
          <img :src="`data:image/png;base64, ${qrImgUrlBase}`" :alt='getLabel("qrCodeImgAlt")' />
        </div>
       {{ getLabel("qrCodeText") }}
      </button>
    </div>
  </aside>
</template>
